import { SlatePlugin } from '../../../../slatePlugins/slatePlugins.types';
import { onKeyDownReadOnly } from './onKeyDownReadOnly';

export const ReadOnlyPlugin = (): SlatePlugin => ({
  onKeyDown: onKeyDownReadOnly,
});
